var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"px-0",attrs:{"items":_vm.modifiedItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }